import React, {Component} from 'react';
import {connect} from 'react-redux';

import api from '../../../../../api.js';
import conf from '../../../../../shared/conf.js';

import ReviewLoaded from './Component/ReviewLoaded.jsx';
import ReviewLoading from './Component/ReviewLoading.jsx';
import MustBeAdmin from '../../../../components/Must/MustBeAdmin.jsx';
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endReview: false,
      globalRating: 0,
      humanSkills: [],
      reviewId: null,
      skills: [],
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if(this.props.freelance && this.props.freelance.id !== prevProps.freelance.id) {
      this.setState({
        endReview: false,
        reviewId: null,
      });
      this.loadHumanSkills(this.props.freelance);
    }
  }

  componentDidMount() {
    this.loadHumanSkills(this.props.freelance);
  }

  loadHumanSkills = async (freelance) => {
    try {
      const humanSkills = this.props.humanSkills.filter(skill => skill.account_type === conf.accountTypes.do);
      this.setState({
        humanSkills: this.lightenSkills(humanSkills),
        skills: this.lightenSkills(freelance.master_skills)
      });

      this.loadFreelanceReview(freelance);
    } catch(e) {
      console.warn(e);
      this.setState({humanSkills: []});
    }
  };

  lightenSkills = (skills) => {
    return skills.map(skill => ({
      id: skill.id,
      name: skill.name,
    }));
  }

  loadFreelanceReview = async (freelance) => {
    try {
      const reviewResponse = await api.freelances.reviews.getAll({
        freelance: freelance.id,
      });

      if (reviewResponse.data.reviews.length === 0) {
        return;
      }

      const {human_skills = [], skills = [], id, global_rating} = reviewResponse.data.reviews[0];

      this.setState({
        globalRating: global_rating,
        humanSkills: this.mergeSkillsWithReviewSkills(this.state.humanSkills, human_skills),
        reviewId: id,
        skills: this.mergeSkillsWithReviewSkills(this.state.skills, skills),
      });
    } catch(e) {
      console.warn(e);
      this.setState({
        reviewId: null
      });
    } finally {
      this.setState({
        endReview: true,
      })
    }
  };

  mergeSkillsWithReviewSkills = (skills, reviewSkills) => {
    skills.forEach((skill) => {
      reviewSkills.forEach((reviewSkill) => {
        if (reviewSkill.skill && skill.id === reviewSkill.skill.id) {
          skill.rate = reviewSkill.rate;
        }
      });
    });

    return skills;
  }

  setReviewId = (reviewId) => {
    this.setState({reviewId});
  }

  render() {
    return (
      <FreelancePage className="p-5">
        <h2 className="text-center">Notation</h2>
        <div className="mb-5">
          <p>
            Notation par l'équipe Twineeds des « hard skills » des différents consultants. Permet aux clients de mettre
            en perspective les taux horaires, la capacité à faire des consultants, et leur probabilité de succès.<br/>
            Le système de notation est découpé en 2 parties :
          </p>
          <ul>
            {this.state.endReview ?
              <li>
                Le "tronc commun" ({this.state.humanSkills.length + 1} notes) : par défaut pour chaque consultant,
                notation possible de Séniorité globale et toute autre compétence identifiée pour noter la séniorité
                d'une compétence attendue par Twineeds pour un univers donné. Il n’est pas nécessaire de noter tout le
                tronc commun.
              </li> : ''
            }
            <li>
              Les spécialités du consultant (1 à 8 notes) : notation possible pour toute compétence renseignée dans
              "Compétences - Mes spécialités" sur le profil du consultant.
            </li>
          </ul>
          <p>
            Les "Compétences - Niveau Confirmé (10 max)" du consultant ne sont pas à noter mais permettent d’identifier
            une compétence spécifique.
          </p>
        </div>
        {this.state.endReview ?
          <ReviewLoaded
            freelanceId={this.props.freelance.id}
            globalRating={this.state.globalRating}
            humanSkills={this.state.humanSkills}
            reviewId={this.state.reviewId}
            setReviewId={this.setReviewId}
            skills={this.state.skills}
            updateReviews={() => {
              return
            }}
          /> : <ReviewLoading/>
        }
      </FreelancePage>
    );
  }
}

export default connect(
  (state) => ({
    humanSkills: state.universe?.currentUniverse.human_skills?.length ? state.universe.currentUniverse.human_skills : []
  })
)(MustBeAdmin(Review));